import React, { useEffect, useState, useRef } from "react";
import styles from './HeaderBook.module.scss';
import mainStyles from '../BookBlue.module.scss';

import header_books from '../../../assets/imgs/libro_negocios/libro_header.png';
import libro_solo from '../../../assets/imgs/libro_negocios/libro-solo.png';
import libro_verde from '../../../assets/imgs/libro_negocios/green_book.png';
import vector_pleca from '../../../assets/imgs/libro_negocios/vector_pleca.svg';
import three_reason from '../../../assets/imgs/libro_negocios/RBS-IDEAS-UL 2 1.png';

import ulibertad_amarillo from '../../../assets/imgs/libro_negocios/universidadlalibertad_amarillo.svg';
import Modal from "../../../components/modal/Modal";

import start from '../../../assets/imgs/libro_negocios/start.svg';
import icon_play from '../../../assets/imgs/libro_negocios/botonplay.png';

import inspiration_uno from '../../../assets/imgs/libro_negocios/Captura de pantalla 2023-10-13 a la(s) 13.03.png'
import inspiration_dos from '../../../assets/imgs/libro_negocios/Captura de pantalla 2023-10-13 a la(s) 13.03 (1).png'
import inspiration_tres from '../../../assets/imgs/libro_negocios/Captura de pantalla 2023-10-13 a la(s) 13.03 (2).png'

import RbsLottie from '../../../components/lotties/rbs-cta';
// import back_focos from '../../../assets/imgs/libro_negocios/back_focos.svg';

import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { PopupContext } from '../../../context/PopupContext';


const HeaderBook = () => {

    const { t, i18n } = useTranslation("libroAzul");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [variable1, setVariable1] = useState("");
    const [variable2, setVariable2] = useState("");

    const liga_lang1 = '/' + i18n.language + "/LibroSociedades";
    const liga_lang2 = '/' + i18n.language + "/LibroLibertad";

    const { visible, setVisible } = useContext(PopupContext);

    const video1 = '<video controls autoPlay ><source src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/estudiante_IMG_2625.mp4" type="video/mp4" /><source src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/estudiante_IMG_2625.webm" type="video/webm" /></video>';
    const video2 = '<video controls autoPlay ><source src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/estudiante_IMG_2636.mp4" type="video/mp4" /><source src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/estudiante_IMG_2636.webm" type="video/webm" /></video>';
    const video3 = '<video controls autoPlay ><source src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/estudiante_IMG_2638.mp4" type="video/mp4" /><source src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/estudiante_IMG_2638.webm" type="video/webm" /></video>';

    const openModal = (value1, value2, value3) => {
        setVariable1(value1);
        setVariable2(value2);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setVariable1('');
        setVariable2('');
        setIsModalOpen(false);
    };

    return (
        <>
            <div className={styles.HeaderBook}>
                <div className={styles.HeaderBook__wrapper}>
                    <img src={header_books} className={`${styles.HeaderBook__wrapper__img}`} />
                    <div className={styles.HeaderBook__wrapper__right}></div>


                    <div className={styles.HeaderBook__pleca}>
                        <div style={{ textAlign: "center" }}>
                            <p className={`${mainStyles.Book_text} 
                                            ${mainStyles.Book_text__medium}
                                            ${mainStyles.Book_text__medium__header}
                                            ${mainStyles.Book_text__700}
                                            ${mainStyles.Book_text__white}`}>
                                {t("header.the")} <span className={mainStyles.Book_text__yellow}>{(t("header.words"))}</span> {t("header.are")}</p>
                            <p className={`${mainStyles.Book_text} 
                                            ${mainStyles.Book_text__large}
                                            ${mainStyles.Book_text__large__header}
                                            ${mainStyles.Book_text__700}
                                            ${mainStyles.Book_text__white}`}>
                                {t("header.until")} {t("header.there")} <span className={mainStyles.Book_text__yellow}>{t("header.action")}.</span> </p>
                        </div>
                        <div className={styles.HeaderBook__pleca__line} style={{ marginTop: 20 + 'px', marginBottom: 20 + 'px' }}>
                            <img src={vector_pleca} alt="" />
                        </div>
                        <div>
                            <a target='_blank' href="https://ekt.page.link/xQzp8ZZMt9KtZUTM6" className={`${mainStyles.btn} ${mainStyles.btn_yellow} ${styles.btn_with_z_index}`} style={{ color: "white" }} >
                                {t("header.buy")}
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/*<div className={styles.rbs_lottie__wrapper}>
                <div className={styles.rbs_lottie}>
                    <RbsLottie />
                </div>
    </div>*/}
            <div className={mainStyles.video}>
                <video controls muted autoPlay poster="https://www.ricardosalinas.com/Content/assets/img/libronegocios/LeandroV_1920x1080.jpg">
                    <source src="/Content/assets/img/libronegocios/LeandroV_1920x1080.mp4" type="video/mp4" />
                    <source src="/Content/assets/img/libronegocios/LeandroV_1920x1080.webm" type="video/webm" />
                </video>
            </div>

            <div className={mainStyles.reasons}>
                <div className={`${mainStyles.reasons__wrapper__text}
                    ${mainStyles.Book_text} 
                    ${mainStyles.Book_text__default} 
                    ${mainStyles.Book_text__400}
                    ${mainStyles.Book_text__white}`}>
                    <p className={mainStyles.first}>
                        {t("reason.i-have-always")} <span className={mainStyles.Book_text__yellow}>
                            {t("reason.a-entrepreneur")}
                        </span>
                    </p>
                    <p>
                        {t("reason.throw-the-years")}
                    </p>
                    <p>
                        {t("reason.i-hope-it")}
                    </p>
                </div>

                <div className={mainStyles.three_reasons}>
                    <div className={mainStyles.three_reasons__wrapper}>
                        <div className={mainStyles.three_reasons__img}>
                            <img src={three_reason} alt="RBS Ideas" />
                        </div>
                        <div className={mainStyles.three_reasons__list}>
                            <p className={`${mainStyles.Book_text} 
                                            ${mainStyles.Book_text__medium_large} 
                                            ${mainStyles.Book_text__700}
                                            ${mainStyles.Book_text__yellow}`}>{t("reason.title-reason")}</p>

                            <ul className={`${mainStyles.Book_text} 
                                            ${mainStyles.Book_text__medium__small} 
                                            ${mainStyles.Book_text__400}
                                            ${mainStyles.Book_text__white}`}>
                                <ol className={mainStyles.number}><div className={mainStyles.number_round}>1</div>{t("reason.reason-one")}</ol>
                                <ol className={mainStyles.number}><div className={mainStyles.number_round}>2</div>{t("reason.reason-two")}</ol>
                                <ol className={mainStyles.number}><div className={mainStyles.number_round}>3</div>{t("reason.reason-three")}</ol>
                            </ul>
                        </div>
                    </div>
                    <div className={mainStyles.three_reasons__quote} style={{ marginTop: 1.5 + 'em', textAlign: 'right' }}>
                        <p className={`${mainStyles.Book_text} 
                                            ${mainStyles.Book_text__medium_xlarge} 
                                            ${mainStyles.Book_text__700}
                                            ${mainStyles.Book_text__yellow}`}>
                            {t("reason.quote-reason")}</p>
                        <span style={{ marginLeft: 'auto', marginTop: 20 + 'px', display: 'inline-block' }} className={`${mainStyles.Book_text} 
                                            ${mainStyles.Book_text__medium__small} 
                                            ${mainStyles.Book_text__700}
                                            ${mainStyles.Book_text__yellow}`}>-Ricardo Salinas</span>
                    </div>
                </div>
                <div className={mainStyles.inspiration__div_vids}>
                    <div className={mainStyles.inspiration__div_vids__div1}>

                        <div class="wrapper-video-teaser">
                            <div class="negocios-video-container">
                                <video controls class="teaser-video desktop" poster="https://www.ricardosalinas.com/Content/assets/img/libronegocios/RS-UL_Portada.jpg">
                                    <source src="/Content/assets/img/libronegocios/RS-UL.mp4" type="video/mp4" />
                                    <source src="/Content/assets/img/libronegocios/RS-UL.webm" type="video/webm" />
                                </video>
                            </div>
                        </div>

                    </div>
                    <div className={mainStyles.inspiration__div_vids__div2} >

                        <div class="wrapper-video-teaser">
                            <div class="negocios-video-container">
                                <video controls class="teaser-video desktop" poster="https://www.ricardosalinas.com/Content/assets/img/libros/poster-video-azul-escritorio.jpg">
                                    <source src="/Content/assets/img/libronegocios/IDEAS_3.mp4" type="video/mp4" />
                                    <source src="/Content/assets/img/libronegocios/IDEAS_3.webm" type="video/webm" />
                                </video>
                            </div>
                        </div>

                        <div class="wrapper-video-teaser">
                            <div class="negocios-video-container">
                                <video controls class="teaser-video-interview" poster="https://www.ricardosalinas.com/Content/assets/img/libronegocios/lb_azul_antonella.jpg ">
                                    <source src="/Content/assets/img/libronegocios/Antonella Marty_2_Final.mp4" type="video/mp4" />
                                    <source src="/Content/assets/img/libronegocios/Antonella Marty_2_Final.webm" type="video/webm" />
                                </video>
                            </div>
                        </div>

                        <div class="wrapper-video-teaser">
                            <div class="negocios-video-container">
                                <video controls class="teaser-video-interview" poster="https://www.ricardosalinas.com/Content/assets/img/libronegocios/Portada-EntrevistaRS-1080p2.jpg ">
                                    <source src="/Content/assets/img/libronegocios/Entrevista-RS-landing.mp4" type="video/mp4" />
                                    <source src="/Content/assets/img/libronegocios/Entrevista-RS-landing.webm" type="video/webm" />
                                </video>
                            </div>
                        </div>

                    </div>


                </div>
            </div>

            <div className={mainStyles.libraries}>
                <div className={mainStyles.libraries__wrapper}>

                    <div>
                        <p className={`${mainStyles.Book_text} 
                                            ${mainStyles.Book_text__medium} 
                                            ${mainStyles.Book_text__700}
                                            ${mainStyles.Book_text__yellow}`}>
                            {t("libraries.available-inprestigious")}
                        </p>
                    </div>
                    <div>
                        <div className={`${mainStyles.logos} ${mainStyles.logos__pleca}`}>
                            <a href='https://ekt.page.link/xQzp8ZZMt9KtZUTM6' target='_blank' rel="noreferer" className={mainStyles.logos__wrapper}>
                                <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Elektra-Gris.svg" alt="elektra" className={mainStyles.logos__img} />
                                <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Elektra-Color.svg" alt="elektra" className={mainStyles.logos__img} />
                            </a>
                            <a href='https://www.gandhi.com.mx/ideas-que-transforman-negocios-para-cambiar-el-mundo/p' target='_blank' className={mainStyles.logos__wrapper}>
                                <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Gandhi-Gris.svg" alt="elektra" className={mainStyles.logos__img} />
                                <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Gandhi-Color.svg" alt="elektra" className={mainStyles.logos__img} />
                            </a>
                            <span className={mainStyles.logos__wrapper}>
                                <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Porrua-Gris.svg" alt="elektra" className={mainStyles.logos__img} />
                                <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Porrua-Color.svg" alt="elektra" className={mainStyles.logos__img} />
                            </span>
                            <span className={mainStyles.logos__wrapper}>
                                <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Sanborns-Gris.svg" alt="elektra" className={mainStyles.logos__img} />
                                <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Sanborns-Color.svg" alt="elektra" className={mainStyles.logos__img} />
                            </span>
                            <a href='https://www.amazon.com.mx/Ideas-transforman-negocios-cambiar-mundo/dp/607596732X/ref=sr_1_1?__mk_es_MX=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=K2T1OGRX0TJB&keywords=ideas+que+transforman+negocios+para+cambiar+el+mundo&qid=1697498981&s=books&sprefix=ideas+que+transforman+negocios+para+cambiar+el+mundo%2Cstripbooks%2C283&sr=1-1' target='_blank' rel='noreferer' className={mainStyles.logos__wrapper}>
                                <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Amazon-Gris.svg" alt="elektra" className={mainStyles.logos__img} />
                                <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Amazon-Color.svg" alt="elektra" className={mainStyles.logos__img} />
                            </a>
                        </div>
                    </div>
                    <div className={mainStyles.libraries__other}>
                        <div className={mainStyles.libraries__audio}>
                            <p className={`${mainStyles.Book_text} 
                                            ${mainStyles.Book_text__default} 
                                            ${mainStyles.Book_text__700}
                                            ${mainStyles.Book_text__yellow}`}>
                                {t("libraries.available-as-audio")}
                            </p>
                            <div className={`${mainStyles.logos}`} style={{ flexWrap: 'wrap' }}>
                                <a href='https://www.audible.com/pd/B0CLS46Q88?source_code=ASSORAP0511160006&share_location=pdp' target='_blank' rel='noreferer' className={`${mainStyles.logos__wrapper} ${mainStyles.logos__wrapper__sm}`}>
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Audible-Gris.svg" alt="elektra" className={mainStyles.logos__img} />
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Audible-Color.svg" alt="elektra" className={mainStyles.logos__img} />
                                </a>
                                <a href='https://lanternaudio.com/ideas-que-transforman-negocios-para-cambiar-al-mundo/' target='_blank' rel='noreferer' className={`${mainStyles.logos__wrapper} ${mainStyles.logos__wrapper__sm}`}>
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Lantern-Gris.svg" alt="elektra" className={mainStyles.logos__img} />
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Lantern-Color.svg" alt="elektra" className={mainStyles.logos__img} />
                                </a>
                                <a href='https://www.storytel.com/mx/books/ideas-que-transforman-negocios-para-cambiar-al-mundo-2645263' target='_blank' rel='noreferer' className={`${mainStyles.logos__wrapper} ${mainStyles.logos__wrapper__sm}`}>
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Storytel-Gris.svg" alt="elektra" className={mainStyles.logos__img} />
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Storytel-Color.svg" alt="elektra" className={mainStyles.logos__img} />
                                </a>
                                <a href='https://www.scribd.com/audiobook/678967515/Ideas-que-transforman-negocios-para-cambiar-al-mundo-que-transforman-negocios-para-cambiar-al-mundo' target='_blank' rel='noreferer' className={`${mainStyles.logos__wrapper} ${mainStyles.logos__wrapper__sm}`}>
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Scribd-Gris.svg" alt="elektra" className={mainStyles.logos__img} />
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Scribd-Color.svg" alt="elektra" className={mainStyles.logos__img} />
                                </a>
                                <a href='https://www.kobo.com/mx/es/audiobook/ideas-12' target='_blank' rel='noreferer' className={`${mainStyles.logos__wrapper} ${mainStyles.logos__wrapper__sm}`}>
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Kobo-Gris.svg" alt="elektra" className={mainStyles.logos__img} />
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Kobo-Color.svg" alt="elektra" className={mainStyles.logos__img} />
                                </a>
                                {/* <span className={`${mainStyles.logos__wrapper} ${mainStyles.logos__wrapper__sm}`}>
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Podimo-Gris.svg" alt="elektra" className={mainStyles.logos__img} />
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Podimo-Color.svg" alt="elektra" className={mainStyles.logos__img} />
                                </span> */}
                                <a href='https://play.google.com/store/audiobooks/details/Ricardo_B_Salinas_Ideas?id=AQAAAEDiV2wXnM&hl=es_MX&gl=US' target='_blank' rel='noreferer' className={`${mainStyles.logos__wrapper} ${mainStyles.logos__wrapper__sm}`}>
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Googleplay-Gris.svg" alt="elektra" className={mainStyles.logos__img} />
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Googleplay-Color.svg" alt="elektra" className={mainStyles.logos__img} />
                                </a>
                            </div>
                        </div>
                        <div className={mainStyles.libraries__ebook}>
                            <p className={`${mainStyles.Book_text} 
                                            ${mainStyles.Book_text__default} 
                                            ${mainStyles.Book_text__700}
                                            ${mainStyles.Book_text__yellow}`}>
                                {t("libraries.available-as-eBook")}
                            </p>
                            <div className={mainStyles.logos} style={{ flexWrap: 'wrap' }}>
                                <a href='https://www.amazon.com.mx/dp/B0CLGQK4ZL' target='_blank' className={`${mainStyles.logos__wrapper} ${mainStyles.logos__wrapper__sm}`}>
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Kindle-Gris.svg" alt="elektra" className={mainStyles.logos__img} />
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Kindle-Color.svg" alt="elektra" className={mainStyles.logos__img} />
                                </a>
                                <a href='https://play.google.com/store/books/details?id=ubPdEAAAQBAJ' target='_blank' className={`${mainStyles.logos__wrapper} ${mainStyles.logos__wrapper__sm}`}>
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Googleplay-Gris.svg" alt="elektra" className={mainStyles.logos__img} />
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Googleplay-Color.svg" alt="elektra" className={mainStyles.logos__img} />
                                </a>
                                <span className={`${mainStyles.logos__wrapper} ${mainStyles.logos__wrapper__sm}`}>
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_AppleBooks-Gris.svg" alt="elektra" className={mainStyles.logos__img} />
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_AppleBooks-Color.svg" alt="elektra" className={mainStyles.logos__img} />
                                </span>
                                <span className={`${mainStyles.logos__wrapper} ${mainStyles.logos__wrapper__sm}`}>
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Kobo-Gris.svg" alt="elektra" className={mainStyles.logos__img} />
                                    <img src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/logos/Logos-Iconos-Assets_Kobo-Color.svg" alt="elektra" className={mainStyles.logos__img} />
                                </span>
                            </div>
                        </div>
                    </div>



                </div>


            </div>

            <div className={mainStyles.inspiration} >
                
                <div style={{ marginBottom: 4 + 'em' }}>
                    <p className={`${mainStyles.Book_text} ${mainStyles.Book_text__default} ${mainStyles.Book_text__700} ${mainStyles.Book_text__yellow} ${mainStyles.Book_text__flex} ${mainStyles.Book__padding}`}>
                        {t("inspirations.title")} <span className={`${mainStyles.hidden__bar}`}>|</span> <img src={ulibertad_amarillo} className={mainStyles.ulibertad_amarillo} />
                    </p>
                </div>
                <div className={mainStyles.inspiration__wrapper}>
                    <div className={mainStyles.inspiration__card}>
                        <p className={`${mainStyles.Book_text} ${mainStyles.Book_text__medium__small} ${mainStyles.Book_text__400} ${mainStyles.Book_text__white}`}>
                            <strong>“{t("inspirations.student-one")}”.</strong>
                        </p>
                        <div style={{ cursor: "pointer" }} onClick={() => openModal(video1, "", "")} className={mainStyles.wrapper_play}>

                            <img src={inspiration_uno} alt="" className={mainStyles.inspiration__img} />
                            <span className={mainStyles.icon_play}>
                                <img src={icon_play} alt="" />
                            </span>
                        </div>
                        <div className={styles.inspiration_card__footer}>
                            <p className={`${mainStyles.Book_text} ${mainStyles.Book_text__medium__small} ${mainStyles.Book_text__400} ${mainStyles.Book_text__white}`}>
                                Erandi Ramírez Agudo
                            </p><br />
                            <span className={`${mainStyles.Book_text} ${mainStyles.Book_text__small} ${mainStyles.Book_text__400} ${mainStyles.Book_text__yellow}`}>
                                {t("inspirations.student")}
                            </span>
                            <div className={mainStyles.starts}>
                                <span className={mainStyles.strats__wrapper}><img src={start} className={mainStyles.starts__svg} alt="" /></span>
                                <span className={mainStyles.strats__wrapper}><img src={start} className={mainStyles.starts__svg} alt="" /></span>
                                <span className={mainStyles.strats__wrapper}><img src={start} className={mainStyles.starts__svg} alt="" /></span>
                                <span className={mainStyles.strats__wrapper}><img src={start} className={mainStyles.starts__svg} alt="" /></span>
                                <span className={mainStyles.strats__wrapper}><img src={start} className={mainStyles.starts__svg} alt="" /></span>
                            </div>
                        </div>
                    </div>
                    <div className={mainStyles.inspiration__card}>
                        <p className={`${mainStyles.Book_text} ${mainStyles.Book_text__medium__small} ${mainStyles.Book_text__400} ${mainStyles.Book_text__white}`}>
                            <strong>“{t("inspirations.student-two")}”.          <span style={{ opacity: 0 }}>ssssssss</span></strong>
                        </p>
                        <div style={{ cursor: "pointer" }} onClick={() => openModal(video2, "", "")} className={mainStyles.wrapper_play}>
                            <img src={inspiration_dos} alt="" className={mainStyles.inspiration__img} />
                            <span className={mainStyles.icon_play}>
                                <img src={icon_play} alt="" />
                            </span>
                        </div>
                        <div className={styles.inspiration_card__footer}>
                            <p className={`${mainStyles.Book_text} ${mainStyles.Book_text__medium__small} ${mainStyles.Book_text__400} ${mainStyles.Book_text__white}`}>
                                Enrique Verjel
                            </p><br />
                            <span className={`${mainStyles.Book_text} ${mainStyles.Book_text__small} ${mainStyles.Book_text__400} ${mainStyles.Book_text__yellow}`}>
                                {t("inspirations.student")}
                            </span>
                            <div className={mainStyles.starts}>
                                <span className={mainStyles.strats__wrapper}><img src={start} className={mainStyles.starts__svg} alt="" /></span>
                                <span className={mainStyles.strats__wrapper}><img src={start} className={mainStyles.starts__svg} alt="" /></span>
                                <span className={mainStyles.strats__wrapper}><img src={start} className={mainStyles.starts__svg} alt="" /></span>
                                <span className={mainStyles.strats__wrapper}><img src={start} className={mainStyles.starts__svg} alt="" /></span>
                                <span className={mainStyles.strats__wrapper}><img src={start} className={mainStyles.starts__svg} alt="" /></span>
                            </div>
                        </div>
                    </div>
                    <div className={mainStyles.inspiration__card}>
                        <p className={`${mainStyles.Book_text} ${mainStyles.Book_text__medium__small} ${mainStyles.Book_text__400} ${mainStyles.Book_text__white}`}>
                            <strong>“{t("inspirations.student-three")}”.</strong>
                        </p>
                        <div style={{ cursor: "pointer" }} onClick={() => openModal(video3, "", "")} className={mainStyles.wrapper_play}>
                            <img src={inspiration_tres} alt="" className={mainStyles.inspiration__img} />
                            <span className={mainStyles.icon_play}>
                                <img src={icon_play} alt="" />
                            </span>
                        </div>
                        <div className={styles.inspiration_card__footer}>
                            <p className={`${mainStyles.Book_text} ${mainStyles.Book_text__medium__small} ${mainStyles.Book_text__400} ${mainStyles.Book_text__white}`}>
                                Alan Pérez
                            </p><br />
                            <span className={`${mainStyles.Book_text} ${mainStyles.Book_text__small} ${mainStyles.Book_text__400} ${mainStyles.Book_text__yellow}`}>
                                {t("inspirations.student")}
                            </span>
                            <div className={mainStyles.starts}>
                                <span className={mainStyles.strats__wrapper}><img src={start} className={mainStyles.starts__svg} alt="" /></span>
                                <span className={mainStyles.strats__wrapper}><img src={start} className={mainStyles.starts__svg} alt="" /></span>
                                <span className={mainStyles.strats__wrapper}><img src={start} className={mainStyles.starts__svg} alt="" /></span>
                                <span className={mainStyles.strats__wrapper}><img src={start} className={mainStyles.starts__svg} alt="" /></span>
                                <span className={mainStyles.strats__wrapper}><img src={start} className={mainStyles.starts__svg} alt="" /></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                isOpen={isModalOpen}
                closeModal={closeModal}
                variable1={variable1}
                variable2={variable2}
            />
            <div className={mainStyles.download}>
                <div className={mainStyles.download__text}>
                    <p className={`${mainStyles.Book_text} ${mainStyles.Book_text__large} ${mainStyles.Book_text__700} ${mainStyles.Book_text__white}`}>

                        <div dangerouslySetInnerHTML={{ __html: (t('register.n-text')) }} />

                        {/* un fragmento <span className={`${mainStyles.Book_text__yellow}`}>exclusivo</span> de mi nuevo libro! */}
                    </p>
                    <button onClick={() => { setVisible(true) }} style={{ marginTop: 20 + 'px' }} className={`${mainStyles.btn} ${mainStyles.btn_yellow}`}>
                        {t("register.download-button")}
                    </button>
                </div>
                <div className={mainStyles.download__img}>
                    <img src={libro_solo} alt="" />
                </div>
            </div>

            {/* <div className={mainStyles.aslo_colection}>
                <div style={{ marginBottom: 4 + 'em' }}>
                    <p className={`${mainStyles.Book_text} ${mainStyles.Book_text__default} ${mainStyles.Book_text__700} ${mainStyles.Book_text__yellow}`}>
                        <div dangerouslySetInnerHTML={{ __html:  (t("aslo.aslo")) }} />
                    </p>
                </div>
                <div className={mainStyles.current_book}>
                    <img src={libro_verde} alt="Libro Sociedades" />
                    <div className={`${mainStyles.absolute_btn}`}>
                        <a href={liga_lang1} style={{ marginTop: 20 + 'px' }} className={`${mainStyles.btn} ${mainStyles.btn_yellow}`}>
                        {t("aslo.more-info")}
                        </a>
                    </div>
                </div>
                <div className={mainStyles.controls}>
                    <div className={mainStyles.controls_item}>
                        <p className={`${mainStyles.Book_text} ${mainStyles.Book_text__medium__small} ${mainStyles.Book_text__400} ${mainStyles.Book_text__white} ${mainStyles.btn__hidden}`}>
                            {t("aslo.society")}
                        </p>
                        <div className={`${mainStyles.hr_tab} ${mainStyles.hr_tab__green}`} ></div>
                        <a href={liga_lang1} style={{ marginTop: 20 + 'px' }} className={`${mainStyles.btn} ${mainStyles.btn_yellow} ${mainStyles.btn__block} ${mainStyles.btn__hidden}`}>
                            {t("aslo.more-info")}
                        </a>
                        <span className={`${mainStyles.label__book} ${mainStyles.label__book__green} ${mainStyles.label__book__green__active} ${mainStyles.label__book__hidden}`}><a className={`${mainStyles.label__book__mb_1} ${mainStyles.label__book__white} ${mainStyles.label__book__hidden}`} href={liga_lang1}> {t("aslo.society-mobile")}</a></span>
                    </div>
                    <div className={mainStyles.controls_item}>
                        <p className={`${mainStyles.Book_text} ${mainStyles.Book_text__medium__small} ${mainStyles.Book_text__400} ${mainStyles.Book_text__white} ${mainStyles.btn__hidden}`}>
                            {t("aslo.freedom")}
                        </p>
                        <div className={`${mainStyles.hr_tab} ${mainStyles.hr_tab__white}`} ></div>
                        <a href={liga_lang2} style={{ marginTop: 20 + 'px' }} className={`${mainStyles.btn} ${mainStyles.btn_yellow} ${mainStyles.btn__hidden}`}>
                            {t("aslo.more-info")}
                        </a>
                        <span className={`${mainStyles.label__book} ${mainStyles.btn_yellow} ${mainStyles.label__book__white} ${mainStyles.label__book__hidden}`}><a className={`${mainStyles.label__book__white} ${mainStyles.label__book__mb_1} ${mainStyles.label__book__hidden}`} href={liga_lang2}>{t("aslo.freedom-mobile")}</a></span>
                    </div>
                </div>

            </div> */}
        </>
    );



}

export default HeaderBook;